var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowLeftLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "pnhwa",
    d: "M1015.07 5111.09h-11.375l3.576-3.807a1.02 1.02 0 0 0 .272-.702c0-.264-.096-.515-.272-.7l-.556-.592a.894.894 0 0 0-1.314 0l-6.13 6.51a1.01 1.01 0 0 0-.27.7c-.002.266.095.515.27.701l6.13 6.512a.897.897 0 0 0 1.314 0l.556-.59c.176-.187.272-.435.272-.7a.98.98 0 0 0-.272-.684l-3.616-3.828h11.402c.512 0 .943-.47.943-1.014v-.836a.973.973 0 0 0-.956-.976"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-999 -5105)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#pnhwa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeftLight);
export default __webpack_public_path__ + "static/media/icon-arrow-left-light.7800f0071cdf03dcf6139e52224b8339.svg";
export { ForwardRef as ReactComponent };